<div style="display: flex; padding-bottom: 10px">
  <div class="open-amount">
    <span>Offener {{ organisation().customFields['amountLabel'] || 'Beitrag' }}</span> <br />
    <span class="text--bold" style="line-height: 2">
      {{ totalAmount() | currency: 'EUR' : 'code' : '1.2-2' }}
    </span>
  </div>
  @if (!organisation().customFields['hideDetails']) {
    <div style="flex: 1" class="open-amount">
      <button
        (click)="toggleDetailsVisibility()"
        class="invisible-button right"
        style="margin-top: unset; height: 100%; display: flex"
      >
        <div>
          <span class="material-symbols-outlined details-icon" aria-hidden="true">{{
            isHidden ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
          }}</span>
          <span class="text--bold">{{ buttonText }}</span>
        </div>
      </button>
    </div>
  }
</div>

@if (!organisation().customFields['hideDetails']) {
  <div [style.visibility]="visibility" class="infoblock">
    <div class="infogrid">
      <div><p class="text--bold" style="margin: 10px 0 5px 5px">Beschreibung</p></div>
      <div>
        <p class="text--bold right">{{ organisation().customFields['amountLabel'] || 'Beitrag' }}</p>
      </div>
    </div>

    @for (contract of contracts(); track contract) {
      <ez-contract-info [contract]="contract"></ez-contract-info>
    }

    <div class="infogrid" style="margin-bottom: 10px">
      <div><p class="text--bold" style="margin: 10px 0 5px 5px">Summe</p></div>
      <div>
        <p class="text--bold right" style="margin-bottom: 5px">
          {{ totalAmount() | currency: 'EUR' : 'code' : '1.2-2' }}
        </p>
      </div>
    </div>
  </div>
}
